import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { HealthMetricsService } from '../health-metrics.service';
import { ComponentBase } from '@drl/core/component-base';
import { Patient } from '@drl/shared/models';
import { MEDICINE_LOG_STATUS } from '../shared/enums/medicine-log.enum';
import { PatientEhrDataFacadeService } from '../patient-ehr-data-facade.service';
import { PrescriptionStatus } from '@drl/shared/utility/patients-caregiver-utility.enum';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

@Component({
  selector: 'app-med-log-dialouge-stepper',
  templateUrl: './med-log-dialouge-stepper.component.html',
  styleUrls: ['./med-log-dialouge-stepper.component.scss']
})
export class MedLogDialougeStepperComponent extends ComponentBase implements OnChanges{

  steps = [];
  @Input() display: boolean = false;
  @Input() patientId: number;
  @Input() patient: Patient;
  @Output() onClose = new EventEmitter<void>();
  loading: boolean = false;

  constructor(
    private readonly healthMetricsFacade: HealthMetricsService,
    private readonly patientEhrDataFacade: PatientEhrDataFacadeService,
    private datePipe: DatePipe,
    protected readonly translateSvc: TranslateService,
  ) {
    super();
  }

  ngOnInit(): void {
  }
  
  ngOnChanges() {

    if(this.patientId){
      this.getMedicineLogs();
    }
    
  }

  getMedicineLogs() {
    this.loading = true;
    this._subscriptions.push(
      this.patientEhrDataFacade.getPatientPrecriptions(this.patientId, PrescriptionStatus.Active.toString()).subscribe(res => {
        const currentDate = new Date();
        const activePrescriptions = res.find(pres => {
          if (!pres.fillDate || !pres.completionDate) return false;
        
          const fillDate = moment(pres.fillDate).startOf('day');
          const completionDate = moment(pres.completionDate).endOf('day');
        
          return moment(currentDate).isBetween(fillDate, completionDate, undefined, '[]');
        });
        

        if (!activePrescriptions?.id) {
          this.loading = false;
          this.steps = [];
          return;
        }
        this._subscriptions.push(this.healthMetricsFacade.getMedicineLogs(this.patientId, undefined, undefined, 'timeToTake DESC', activePrescriptions.id).subscribe(res => {
          this.steps = res.map(log => {
            const medicineStatus = this.translateSvc.instant(
              log.status === MEDICINE_LOG_STATUS.DONE
                ? 'taken'
                : log.status === MEDICINE_LOG_STATUS.MISSED
                  ? 'notTaken'
                  : 'missed');
            const className =
              log.status == MEDICINE_LOG_STATUS.DONE ? 'dot-green' :
                log.status === MEDICINE_LOG_STATUS.MISSED ? 'dot-red' : 'dot-grey';

            const dateFormatted = this.datePipe.transform(log.timeToTake, 'dd MMM, HH:mm a');
            let comment = log.comment ? this.translateSvc.instant(log.comment) : '';
            if( ![MEDICINE_LOG_STATUS.MISSED,MEDICINE_LOG_STATUS.DONE].includes(log.status)){
              comment = this.translateSvc.instant('patientNotMarked');
            }
            return ({
              title: dateFormatted + ' — ' + (medicineStatus),
              sub: comment,
              completed: log.status === MEDICINE_LOG_STATUS.DONE,
              className: className
            })

          });
          this.loading = false;
          this.display = true;
        }, err => {
          this.loading = false;
          this.steps = [];
        }));

      }, err => {
        this.loading = false;
        this.steps = [];
      })
    );
  }

  onDialogHide() {
    this.display = false;
    this.patientId = null;
    this.patient = null;
    this.onClose.emit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.display = false;
    this.display = false;
    this.patientId = null;
    this.patient = null;
  }

}

